module.exports = require('../abstract').extend
  template: require('./index.pug')

  props:
    popupKey:         { default: null }
    title:            { default: null }
    closeText:        { default: null }
    mode:             { default: 'overlay' }
    hideBackdrop:     { default: false }
    hideCloseButton:  { default: false }
    showCloseButton:  { default: false }

  computed:

    hasBackdrop: ->
      @hideBackdrop == false || @hideBackdrop == 'false'

    hasHeader: ->
      @mode == 'window' || @mode == 'modal'

    hasFooter: ->
      @mode == 'alert' || @mode == 'confirm' || @mode == 'modal'

    hasCloseButton: ->
      return true if @showCloseButton == true || @showCloseButton == 'true'
      return false if @hideCloseButton == true || @hideCloseButton == 'true'

      @mode == 'window'

    styleInside: ->
      style = {}
      style

    styleMain: ->
      style = {}
      style

  methods:

    onClickBackdrop: ->
      @.$emit('click-backdrop')

    onClickBtnClose: ->
      @.$emit('click-close')



// WEBPACK FOOTER //
// ./assets/js/shared_frontend/components/popup_content/index.coffee